
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/employer/retail-fnb-hospitality",
      function () {
        return require("private-next-pages/employer/retail-fnb-hospitality.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/employer/retail-fnb-hospitality"])
      });
    }
  